export default {
  pt_BR: {
    message: {
      tank: 'Tanque',
      volume: 'Volume',
      volume_meter: 'Medidor de volume',
      sensors: 'Sensores',
      identifier: 'Identificador',
      account: 'Conta',
      entries: 'Cadastros',
      width: 'Largura',
      height: 'Altura',
      length: 'Comprimento',
      date: 'Data',
      reading: 'Leitura',
      readings: 'Leituras',
      statistic: 'Estátistica',
      statistics: 'Estátisticas',
      inobram_plataform: 'Plataforma Inobram',
      enter: 'Entrar',
      add: 'Adicionar',
      add_device: 'Adicionar dispositivo',
      list_devices: 'Listar dispositivos',
      device: 'Dispositivo',
      devices: 'Dispositivos',
      type: 'Tipo',
      description: 'Descrição',
      indicates_that_the_field_is_required: '*Indica que o campo é obrigatório',
      create_your_account: 'Crie sua conta',
      create: 'Criar',
      cancel: 'Cancelar',
      save: 'Salvar',
      save_for_all: 'Salvar para todos',
      name: 'Nome',
      password: 'Senha',
      confirm_the_password: 'Confirme a senha',
      password_must_be_at_least_6_characters: 'A senha deve ter ao menos 6 caracteres',
      the_password_is_invalid_or_the_user_does_not_have_a_password: 'A senha é inválida ou o usuário não possui uma senha.',
      the_email_address_is_badly_formatted: 'O endereço de email está mal formatado.',
      there_is_no_user_record_corresponding_to_this_identifier_the_user_may_have_been_deleted: 'Não há registro de usuário correspondente a esse identificador. O usuário pode ter sido excluído.',
      profile: 'Perfil',
      add_nucleus: 'Adicionar núcleo',
      list_nuclei: 'Listar núcleos',
      nuclei: 'Núcleos',
      nucleus: 'Núcleo',
      add_property: 'Adicionar propriedade',
      edit_property: 'Editar propriedade',
      properties: 'Propriedades',
      users: 'Usuários',
      add_user: 'Adicionar usuário',
      updated_at: 'Atualizado em',
      reports_and_settings: 'Relatórios e configurações',
      water_consumption_today: 'Consumo de água hoje',
      feed_level: 'Nível de ração',
      yes: 'Sim',
      no: 'Não',
      alerts: 'Alertas',
      settings: 'Configurações',
      not_connected: 'Não conectado',
      inobram_account: 'Conta da Inobram',
      navigation_menu: 'Menu de navegação',
      exit: 'Sair',
      added_at: 'Adicionado em',
      added_by: 'Adicionado por',
      edit: 'Editar',
      delete: 'Excluir',
      close: 'Fechar',
      all: 'Todos',
      rows_per_page: 'Linhas por página',
      no_data: 'Nenhum dado disponível',
      items_to_show: 'Itens para mostrar',
      chage_view_mode: 'Altera o modo de visualização',
      setting_alarm_value: 'Configura os valores para alarmes',
      invalid_mac: 'MAC inválido',
      invalid_mac_pattern: 'Padrão do MAC inválido',
      to_view: 'Visualizar',
      minimum: 'Mínimo',
      maximum: 'Máximo',
      alarm_level: 'Nível do alarme',
      next: 'Próximo',
      previous: 'Anterior',
      countries: 'Países',
      states: 'Estados',
      cities: 'Cidades',
      sexes: 'Sexos',
      country: 'País',
      state: 'Estado',
      city: 'Cidade',
      sex: 'Sexo',
      device_models: 'Modelos de dispositivo',
      device_types: 'Tipos de dispositivo',
      mortalities: 'Mortalidades',
      device_model: 'Modelo de dispositivo',
      device_type: 'Tipo de dispositivo',
      mortality: 'Mortalidade',
      quantity: 'Quantidade',
      batch: 'Lote',
      wall: 'Parede',
      walls: 'Paredes',
      floor: 'Piso',
      floors: 'Pisos',
      roof: 'Cobertura',
      roofs: 'Coberturas',
      inner_curtain: 'Cortina interna',
      inner_curtains: 'Cortinas internas',
      outer_curtain: 'Cortina externa',
      outer_curtains: 'Cortinas externas',
      lining: 'Forro',
      linings: 'Forros',
      evaporative_plate: 'Placa evaporativa',
      evaporative_plates: 'Placas evaporativas',
      lighting_system: 'Sistema de iluminação',
      lighting_systems: 'Sistemas de iluminações',
      internet_access_type: 'Tipo de acesso a Internet',
      internet_access_types: 'Tipos de acesso a Internet',
      barn: 'Galpão',
      barns: 'Galpões',
      barn_type: 'Tipo de galpão',
      barn_types: 'Tipos de galpões',
      voltage_type: 'Tipo de tensão',
      voltage_types: 'Tipos de tensões',
      air_inlet: 'Entrada de ar',
      air_inlets: 'Entradas de ar',
      silo_type: 'Tipo de silo',
      silo_types: 'Tipos de silo',
      water_box: 'Caixa de água',
      water_boxes: 'Caixas de água',
      watchdog_system: 'Sistema de watchdog',
      watchdog_systems: 'Sistemas de watchdog',
      batch_state: 'Estado do lote',
      batch_states: 'Estados do lote',
      capacity: 'Capacidade',
      manufacturer: 'Fabricante',
      manufacturers: 'Fabricantes'
    },
    alarm: {
      alarm: 'Alarme',
      alarms: 'Alarmes',
      high_temperature: 'Temperatura alta',
      low_temperature: 'Temperatura baixa',
      high_humidity: 'Umidade alta',
      low_humidity: 'Umidade baixa',
      high_pressure: 'Pressão alta',
      low_pressure: 'Pressão baixa',
      low_battery: 'Bateria baixa',
      low_source: 'Falta de energia',
      no_probe_installed: 'Sem sonda instalada',
      null_temperature: 'Temperatura zerada',
      probe_error: 'Erro em sonda',
      relay_error: 'Erro na placa de rele',
      LEIT_SONDA: 'Erro na leitura de sonda',
      INST_SONDA: 'Erro na instalação de sonda',
      TEMP_ALTA: 'Temperatura baixa',
      TEMP_BAIXA: 'Temperatura baixa',
      UMIDADE_ALTA: 'Umidade alta',
      UMIDADE_BAIXA: 'Umidade baixa',
      PRESSAO_ALTA: 'Pressão alta',
      PRESSAO_BAIXA: 'Pressão baixa',
      BATERIA_BAIXA: 'Bateria baixa',
      FALTA_ENERGIA: 'Falta de energia',
      DESARME_CORT: 'Desarme de cortina',
      ERROR_RELAY: 'Erro na placa de rele',
      ERRO_SONDA_T1: 'Erro na sonda T1',
      ERRO_SONDA_T2: 'Erro na sonda T2',
      ERRO_SONDA_T3: 'Erro na sonda T3',
      ERRO_SONDA_T4: 'Erro na sonda T4',
      ERRO_SONDA_T5: 'Erro na sonda T5',
      ERRO_SONDA_TU1: 'Erro na sonda TU1',
      ERRO_SONDA_TU2: 'Erro na sonda TU2',
      ERRO_SONDA_TU3: 'Erro na sonda TU3',
      ERRO_SONDA_U1: 'Erro na sonda U1',
      ERRO_SONDA_U2: 'Erro na sonda U2',
      ERRO_SONDA_P1: 'Erro na sonda P1',
      ERRO_SONDA_CO21: 'Erro na sonda CO21',
      ERRO_SONDA_H2O1: 'Erro na sonda H2O1'
    },
    notification: {
      attention: 'Atenção',
      confirm_exclusion: 'Confirma exclusão?',
      saved_successfully: 'Salvo com sucesso!',
      there_was_an_error_saving: 'Ocorreu um erro ao salvar'
    },
    environment: {
      age: 'Idade',
      temperature: 'Temperatura',
      humidity: 'Umidade',
      pressure: 'Pressão',
      water: 'Água',
      weight: 'Peso',
      desired_weight: 'Peso desejado',
      silo: 'Silo',
      desired_temperature: 'Temperatura desejada',
      desired_humidity: 'Umidade desejada',
      desired_pressure: 'Pressão desejada'
    },
    prefix: {
      ag: 'Id',
      dt: 'Td',
      at: 'T',
      dh: 'Ud',
      ah: 'U',
      wt: 'Ag (L)',
      dw: 'Pd (g)',
      aw: 'Pm (g)',
      dp: 'Pd (Pa)',
      ap: 'P (Pa)',
      s1: 'S1',
      s2: 'S2',
      st: 'Estado',
      t_max: 'T max',
      t_min: 'T min',
      h_max: 'U max',
      h_min: 'U min',
      p_max: 'P max',
      p_min: 'P min',
      co2_max: 'co2 max',
      co2_min: 'cvo2 min',
      h2o_acc: 'h2o acumulado'
    },
    table: {
      of: 'de',
      all: 'Todas',
      rows_per_page_text: 'Linhas por página'
    }
  },
  en_US: {
    message: {
      tank: 'Tank',
      volume: 'Volume',
      volume_meter: 'Volume meter',
      sensors: 'Sensors',
      identifier: 'Identifier',
      account: 'Account',
      entries: 'Entries',
      width: 'Width',
      height: 'Height',
      length: 'Length',
      date: 'Date',
      reading: 'Reading',
      readings: 'Readings',
      statistic: 'Statistic',
      statistics: 'Statistics',
      inobram_plataform: 'Inobram Plataform',
      enter: 'Enter',
      add: 'Add',
      add_device: 'Add Device',
      list_devices: 'List Devices',
      device: 'Device',
      devices: 'Devices',
      type: 'Type',
      description: 'Description',
      indicates_that_the_field_is_required: '*Indicates that the field is required',
      create_your_account: 'Create your account',
      create: 'Create',
      cancel: 'Cancel',
      save: 'Save',
      save_for_all: 'Save for all',
      name: 'Name',
      password: 'Password',
      confirm_the_password: 'Confirm the password',
      password_must_be_at_least_6_characters: 'Password must be at least 6 characters',
      the_password_is_invalid_or_the_user_does_not_have_a_password: 'The password is invalid or the user does not have a password.',
      the_email_address_is_badly_formatted: 'The email address is badly formatted.',
      there_is_no_user_record_corresponding_to_this_identifier_the_user_may_have_been_deleted: 'There is no user record corresponding to this identifier. The user may have been deleted.',
      profile: 'Profile',
      add_nucleus: 'Add nucleus',
      list_nuclei: 'List nuclei',
      nuclei: 'Nuclei',
      nucleus: 'Nucleus',
      add_property: 'Add property',
      edit_property: 'Edit property',
      properties: 'Properties',
      users: 'Users',
      add_user: 'Add user',
      updated_at: 'Updated at',
      reports_and_settings: 'Reports and settings',
      water_consumption_today: 'Water consumption today',
      feed_level: 'Feed level',
      yes: 'Yes',
      no: 'No',
      alerts: 'Alerts',
      settings: 'Settings',
      not_connected: 'Not connected',
      inobram_account: 'Inobram account',
      navigation_menu: 'Navigation menu',
      exit: 'Exit',
      added_at: 'Added at',
      added_by: 'Added by',
      edit: 'Edit',
      delete: 'Delete',
      close: 'Close',
      all: 'All',
      rows_per_page: 'Rows per page',
      no_data: 'No data available',
      items_to_show: 'Items to show',
      chage_view_mode: 'Change view mode',
      setting_alarm_value: 'Setting alarm value',
      invalid_mac: 'Invalid MAC',
      invalid_mac_pattern: 'Invalid MAC pattern',
      to_view: 'To View',
      minimum: 'Minimum',
      maximum: 'Maximum',
      alarm_level: 'Alarm level',
      next: 'Next',
      previous: 'Previus',
      countries: 'Countries',
      states: 'States',
      cities: 'Cities',
      sexes: 'Sexes',
      country: 'Country',
      state: 'State',
      city: 'City',
      sex: 'Sex',
      device_models: 'Device models',
      device_types: 'Device types',
      mortalities: 'Mortalities',
      device_model: 'Device model',
      device_type: 'Device type',
      mortality: 'Mortality',
      quantity: 'Quantity',
      batch: 'Batch',
      wall: 'Wall',
      walls: 'Walls',
      floor: 'Floor',
      floors: 'Floors',
      roof: 'Roof',
      roofs: 'Roofs',
      inner_curtain: 'Inner curtain',
      inner_curtains: 'Inner curtains',
      outer_curtain: 'Outer curtain',
      outer_curtains: 'Outer curtains',
      lining: 'Lining',
      linings: 'Linings',
      evaporative_plate: 'Evaporative plate',
      evaporative_plates: 'Evaporative plates',
      lighting_system: 'Lighting system',
      lighting_systems: 'Lighting systems',
      internet_access_type: 'Internet access type',
      internet_access_types: 'Internet access types',
      barn: 'Barn',
      barns: 'Barns',
      barn_type: 'Barn type',
      barn_types: 'Barn types',
      voltage_type: 'Barn type',
      voltage_types: 'Barn types',
      air_inlet: 'Air inlet',
      air_inlets: 'Air inlets',
      silo_type: 'Silo type',
      silo_types: 'Silo types',
      water_box: 'Water box',
      water_boxes: 'Water boxes',
      watchdog_system: 'Watchdog system',
      watchdog_systems: 'Watchdog systems',
      batch_state: 'Batch state',
      batch_states: 'Batch states',
      capacity: 'Capacity',
      manufacturer: 'Manufacturer',
      manufacturers: 'Manufacturers'
    },
    alarm: {
      alarm: 'Alarm',
      alarms: 'Alarms',
      high_temperature: 'High temperature',
      low_temperature: 'Low temperature',
      high_humidity: 'High humidity',
      low_humidity: 'Low humidity',
      high_pressure: 'High pressure',
      low_pressure: 'Low pressure',
      low_battery: 'Low battery',
      low_source: 'Energy fault',
      no_probe_installed: 'No probe installed',
      null_temperature: 'Temperature zero',
      probe_error: 'Probe error',
      relay_error: 'Relay error',
      LEIT_SONDA: 'Error probe reading',
      INST_SONDA: 'Error probe installation',
      TEMP_ALTA: 'High temperature',
      TEMP_BAIXA: 'Low temperature',
      UMIDADE_ALTA: 'High humidity',
      UMIDADE_BAIXA: 'Low humidity',
      PRESSAO_ALTA: 'High pressure',
      PRESSAO_BAIXA: 'Low pressure',
      BATERIA_BAIXA: 'Low battery',
      FALTA_ENERGIA: 'Power failure',
      DESARME_CORT: 'Curtain disarm',
      ERROR_RELAY: 'Error relay board',
      ERRO_SONDA_T1: 'Error probe T1',
      ERRO_SONDA_T2: 'Error probe T2',
      ERRO_SONDA_T3: 'Error probe T3',
      ERRO_SONDA_T4: 'Error probe T4',
      ERRO_SONDA_T5: 'Error probe T5',
      ERRO_SONDA_TU1: 'Error probe TU1',
      ERRO_SONDA_TU2: 'Error probe TU2',
      ERRO_SONDA_TU3: 'Error probe TU3',
      ERRO_SONDA_U1: 'Error probe U1',
      ERRO_SONDA_U2: 'Error probe U2',
      ERRO_SONDA_P1: 'Error probe P1',
      ERRO_SONDA_CO21: 'Error probe CO21',
      ERRO_SONDA_H2O1: 'Error probe H2O1'
    },
    notification: {
      attention: 'Attention',
      confirm_exclusion: 'Confirm exclusion?',
      saved_successfully: 'Saved successfully!',
      there_was_an_error_saving: 'There was an error saving'
    },
    environment: {
      age: 'Age',
      temperature: 'Temperature',
      humidity: 'Humidity',
      pressure: 'Pressure',
      water: 'Water',
      weight: 'Weight',
      desired_weight: 'Desired weight',
      silo: 'Silo',
      desired_temperature: 'Desired temperature',
      desired_humidity: 'Desired humidity',
      desired_pressure: 'Desired pressure'
    },
    prefix: {
      ag: 'Ag',
      dt: 'Dt',
      at: 'T',
      dh: 'Dh',
      ah: 'H',
      wt: 'Wt (L)',
      dw: 'Dw (g)',
      aw: 'Aw (g)',
      dp: 'Dp (Pa)',
      ap: 'P (Pa)',
      s1: 'S1',
      s2: 'S2',
      st: 'Status',
      t_max: 'T max',
      t_min: 'T min',
      h_max: 'H max',
      h_min: 'H min',
      p_max: 'P max',
      p_min: 'P min',
      co2_max: 'co2 max',
      co2_min: 'cvo2 min',
      h2o_acc: 'h2o accumulated'
    },
    table: {
      of: 'of',
      all: 'All',
      rows_per_page_text: 'Rows per page'
    }
  },
  es_ES: {
    message: {
      tank: 'Tanque',
      volume: 'Volumen',
      volume_meter: 'Medidor de volumen',
      sensors: 'Sensores',
      identifier: 'Identificador',
      account: 'Cuenta',
      entries: 'Entradas',
      width: 'Anchura',
      height: 'Altura',
      length: 'Longitud',
      date: 'Fecha',
      reading: 'Lectura',
      readings: 'Lecturas',
      statistic: 'Estadística',
      statistics: 'Estadísticas',
      inobram_plataform: 'Plataforma Inobram',
      enter: 'Entrar',
      add: 'Añadir',
      add_device: 'Añadir dispositivo',
      list_devices: 'Listar dispositivos',
      device: 'Dispositivo',
      devices: 'Dispositivos',
      type: 'Especie',
      description: 'Descripción',
      indicates_that_the_field_is_required: '*Indica que el campo es obligatorio',
      create_your_account: 'Crea tu cuenta',
      create: 'Crear',
      cancel: 'Cancelar',
      save: 'Guardar',
      save_for_all: 'Guadar para todos',
      name: 'Nombre',
      password: 'Contraseña',
      confirm_the_password: 'Confirme la contraseña',
      password_must_be_at_least_6_characters: 'La contraseña debe tener al menos 6 caracteres',
      the_password_is_invalid_or_the_user_does_not_have_a_password: 'La contraseña no es válida o el usuario no tiene una contraseña.',
      the_email_address_is_badly_formatted: 'La dirección de correo electrónico está mal formateada.',
      there_is_no_user_record_corresponding_to_this_identifier_the_user_may_have_been_deleted: 'No hay registro de usuario correspondiente a este identificador. El usuario puede haber sido eliminado.',
      profile: 'Perfil',
      add_nucleus: 'Añadir núcleo',
      list_nuclei: 'Listar núcleos ',
      nuclei: 'Núcleos',
      nucleus: 'Núcleo',
      add_property: 'Añadir propiedad',
      edit_property: 'Editar propiedad',
      properties: 'Propiedades',
      users: 'Usuários',
      add_user: 'Añadir usuário',
      updated_at: 'Actualizado en',
      reports_and_settings: 'Informes y configuraciones',
      water_consumption_today: 'Consumo de agua hoy',
      feed_level: 'Nível del pienso',
      yes: 'Si',
      no: 'No',
      alerts: 'Alertas',
      settings: 'Ajustes',
      not_connected: 'No conectado',
      inobram_account: 'Cuenta Inobram',
      navigation_menu: 'Menú de navegación',
      exit: 'Salida',
      added_at: 'Añadido a',
      added_by: 'Añadido por',
      edit: 'Editar',
      delete: 'Borrar',
      close: 'Cerrar',
      all: 'Todos',
      rows_per_page: 'Líneas por página',
      no_data: 'Datos no disponibles',
      items_to_show: 'Elementos para mostrar',
      chage_view_mode: 'Cambia el modo de visualización',
      setting_alarm_value: 'Ajuste de valor de alarma',
      invalid_mac: 'MAC inválido',
      invalid_mac_pattern: 'Patrón de MAC no válido',
      to_view: 'Visualizar',
      minimum: 'Mínimo',
      maximum: 'Máximo',
      alarm_level: 'Nivel de alarma',
      next: 'Siguiente',
      previous: 'Anterior',
      countries: 'Países',
      states: 'Estados',
      cities: 'Ciudades',
      sexes: 'Sexos',
      country: 'País',
      state: 'Estado',
      city: 'Ciudad',
      sex: 'Sexo',
      device_models: 'Modelos de dispositivo',
      device_types: 'Tipos de dispositivo',
      mortalities: 'Mortalidades',
      device_model: 'Modelo de dispositivo',
      device_type: 'Tipo de dispositivo',
      mortality: 'Mortalidad',
      quantity: 'Cantidad',
      batch: 'Lote',
      wall: 'Pared',
      walls: 'Paredes',
      floor: 'Piso',
      floors: 'Pisos',
      roof: 'Techo',
      roofs: 'Techos',
      inner_curtain: 'Cortina interior',
      inner_curtains: 'Cortinas interiores',
      outer_curtain: 'Cortina exterior',
      outer_curtains: 'Cortinas exteriores',
      lining: 'Forro',
      linings: 'Forros',
      evaporative_plate: 'Placa evaporativa',
      evaporative_plates: 'Placas evaporativas',
      lighting_system: 'Sistema de iluminación',
      lighting_systems: 'Sistemas de iluminación',
      internet_access_type: 'Tipo de acceso a Internet',
      internet_access_types: 'Tipos de acceso a Internet',
      barn: 'Cobertizo',
      barns: 'Cobertizos',
      barn_type: 'Tipo de cobertizo',
      barn_types: 'Tipos de cobertizos',
      voltage_type: 'Tipo de tensión',
      voltage_types: 'Tipos de tesión',
      air_inlet: 'Entrada de aire',
      air_inlets: 'Entradas de aire',
      silo_type: 'Tipo de silo',
      silo_types: 'Tipos de silo',
      water_box: 'Caja de água',
      water_boxes: 'Cajas de água',
      watchdog_system: 'Sistema de vigilancia',
      watchdog_systems: 'Sistemas de vigilancia',
      batch_state: 'Estado del lote',
      batch_states: 'Estados del lote',
      capacity: 'Capacidad',
      manufacturer: 'Fabricante',
      manufacturers: 'Fabricantes'
    },
    alarm: {
      alarm: 'Alarma',
      alarms: 'Alarmas',
      high_temperature: 'Temperatura alta',
      low_temperature: 'Temperatura baja',
      high_humidity: 'Humedad alta',
      low_humidity: 'Humedad baja',
      high_pressure: 'Presion baja',
      low_pressure: 'Presion baja',
      low_battery: 'Bateria baja',
      low_source: 'Fuente sin energia',
      no_probe_installed: 'Sin sonda instalada',
      null_temperature: 'Leitura de sonda',
      probe_error: 'Erro em sonda',
      relay_error: 'Erro en la placa de rele',
      LEIT_SONDA: 'Error en la lectura de sonda',
      INST_SONDA: 'Error en la instalación de sonda',
      TEMP_ALTA: 'Temperatura alta',
      TEMP_BAIXA: 'Temperatura baja',
      UMIDADE_ALTA: 'Humedad alta',
      UMIDADE_BAIXA: 'Humedad baja',
      PRESSAO_ALTA: 'Presión alta',
      PRESSAO_BAIXA: 'Presión baja',
      BATERIA_BAIXA: 'Batería baja',
      FALTA_ENERGIA: 'Falta de energia',
      DESARME_CORT: 'Desarme de la cortina',
      ERROR_RELAY: 'Erro en la placa de rele',
      ERRO_SONDA_T1: 'Erro en la sonda T1',
      ERRO_SONDA_T2: 'Erro en la sonda T2',
      ERRO_SONDA_T3: 'Erro en la sonda T3',
      ERRO_SONDA_T4: 'Erro en la sonda T4',
      ERRO_SONDA_T5: 'Erro en la sonda T5',
      ERRO_SONDA_TU1: 'Erro en la sonda TU1',
      ERRO_SONDA_TU2: 'Erro en la sonda TU2',
      ERRO_SONDA_TU3: 'Erro en la sonda TU3',
      ERRO_SONDA_U1: 'Erro en la sonda U1',
      ERRO_SONDA_U2: 'Erro en la sonda U2',
      ERRO_SONDA_P1: 'Erro en la sonda P1',
      ERRO_SONDA_CO21: 'Erro en la sonda CO21',
      ERRO_SONDA_H2O1: 'Erro en la sonda H2O1'
    },
    notification: {
      attention: 'Atención',
      confirm_exclusion: 'Confirma la exclusíon?',
      saved_successfully: 'Salvo con éxito!',
      there_was_an_error_saving: 'Hubo un error guardando'
    },
    environment: {
      age: 'Edad',
      temperature: 'Temperatura',
      humidity: 'Humedad',
      pressure: 'Presion',
      water: 'Agua',
      weight: 'Peso',
      desired_weight: 'Peso deseado',
      silo: 'Silo',
      desired_temperature: 'Temperatura deseada',
      desired_humidity: 'Humedad deseada',
      desired_pressure: 'Presión deseada'
    },
    prefix: {
      ag: 'Ed',
      dt: 'Td',
      at: 'T',
      dh: 'Hd',
      ah: 'H',
      wt: 'Ag (L)',
      dw: 'Pd (g)',
      aw: 'Pm (g)',
      dp: 'Pd (Pa)',
      ap: 'P (Pa)',
      s1: 'S1',
      s2: 'S2',
      st: 'Estado',
      t_max: 'T max',
      t_min: 'T min',
      h_max: 'H max',
      h_min: 'H min',
      p_max: 'P max',
      p_min: 'P min',
      co2_max: 'co2 max',
      co2_min: 'cvo2 min',
      h2o_acc: 'h2o acumulado'
    },
    table: {
      of: 'de',
      all: 'Todos',
      rows_per_page_text: 'Líneas por página'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/index.js